import { render, staticRenderFns } from "./TicketStatuses.vue?vue&type=template&id=045c5a91&scoped=true"
import script from "./TicketStatuses.vue?vue&type=script&lang=ts"
export * from "./TicketStatuses.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "045c5a91",
  null
  
)

export default component.exports